module.exports = __webpack_public_path__ + "static/media/carpooling.b7ad77c8.png";